import styles from "./VariantAttributes.module.scss";

type VariantAttributesUIProps = {
  /**
   * An object or string representing the price of the product.
   */
  price: string | undefined;
  /**
   * A boolean representing if the product is sold by the metre.
   */
  isPerMetre: boolean;
  /**
   * A boolean representing whether the price should be hidden for single sku products defaults to false.
   */
  hidePriceForSingleSku: boolean;
};

export const VariantAttributesUI = ({
  price,
  isPerMetre,
  hidePriceForSingleSku = false,
}: VariantAttributesUIProps) => {
  const formatPrice = (price: string) => {
    const priceNumber = parseFloat(price);
    if (isNaN(priceNumber)) {
      return price;
    }
    return new Intl.NumberFormat("en-GB", {
      maximumSignificantDigits: 8,
    }).format(priceNumber);
  };

  return (
    <dl
      data-testid="basket:product:attributes:list"
      className={styles.attributeList}
    >
      {price && !hidePriceForSingleSku && (
        <>
          {isPerMetre && (
            <dt className={styles.attributeEmptyValue}>Total fabric price</dt>
          )}
          <dt className={styles.visuallyHidden}>Price</dt>
          <dd
            data-testid="product:basket:price"
            className={styles.attributeEmptyValue}
          >
            {formatPrice(price)}
          </dd>
        </>
      )}
    </dl>
  );
};
